// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".operate-item[data-v-0b1aefdb]{display:flex;justify-content:center;align-items:center;flex-shrink:0;margin-right:14px;border-radius:6px;line-height:42px;padding:0 18px;cursor:pointer}.operate-item .small-icon[data-v-0b1aefdb]{margin-right:6.5px}.file-items-inner[data-v-0b1aefdb]{display:flex;align-items:center}.file-items-inner-label[data-v-0b1aefdb]{margin-left:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
